import { render, staticRenderFns } from "./NoRole.vue?vue&type=template&id=43181d80&scoped=true"
import script from "./NoRole.vue?vue&type=script&lang=js"
export * from "./NoRole.vue?vue&type=script&lang=js"
import style0 from "./NoRole.vue?vue&type=style&index=0&id=43181d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43181d80",
  null
  
)

export default component.exports